<!-- 预赛 -->
<template>
    <div class="state-pre" v-if="nowTime > preBegin">
      <pre-result v-if="nowTime > preRes" />
      <pre-ended v-else-if="nowTime > preEnd" />
      <pre-playing v-else-if="nowTime > preBegin" />
      <!-- <div v-else>初赛未开始</div> -->
    </div>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'

  import Playing from './pre-playing'
  import Ended from './pre-ended'
  import Result from './pre-result'

  export default {
    name: 'st-pre',
    components: {
      [Playing.name] : Playing,
      [Ended.name] : Ended,
      [Result.name] : Result
    },
    computed: {
      ...mapGetters(['nowTime', 'preBegin', 'preEnd', 'preRes'])
    }
  }
</script>
